import React from 'react';

import { Card, CardContent, Fab } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { fade } from '@material-ui/core/styles/colorManipulator';

import { MuiRouterLink } from '../CustomMui'

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 10,
    overflow: 'visible',
    boxShadow: `0px 5px 18px ${fade(theme.palette.neutral.med, .8)}`,
    boxSizing: 'content-box',
  },
  cardContent: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0,
    }
  },
  cardFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    fontSize: 17,
    lineHeight: '21px',
    padding: '8px 15px',
    minHeight: 47,
    color: theme.palette.text.primary,
    transition: '.3s color',
  },
  cardLink: {
    '&:hover .MuiFab-root': {
      backgroundColor: theme.palette.primary.hover,
    },
    '&:hover $cardFooter': {
      color: theme.palette.primary.hover,
    },
    // '&:hover .MuiCard-root': {
    //   boxShadow: `0px 5px 10px ${fade(theme.palette.neutral.med, .8)}`,
    // }
  },
  image: { 
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    overflow: 'hidden',
    '& img': {
      width: '100%',
      display: 'block',
    },
  },
  fab: {
    position: 'absolute',
    flexShrink: '0',
    right: -5,
    bottom: -5,
  },
}));

// Cards on Dashboard that link to creating new interactives
export const CreateCard = (props) => {

  const classes = useStyles();

  return (
    <MuiRouterLink to={`/${props.name}`} className={classes.cardLink} underline="none">
      <Card className={classes.root}>
        
        {/* icon/image */}
        <div className={classes.image}>
          <img src={require(`../../images/card-${props.name}.png`)} aria-hidden alt=""/>
        </div>

        {/* Card footer */}
        <CardContent className={classes.cardContent}>

          <div className={classes.cardFooter}>
            {props.children}
            <Fab className={classes.fab} component="span" color="primary"><i className="fas fa-plus"></i></Fab>
          </div>

        </CardContent>

      </Card>
    </MuiRouterLink>
  )
}